import { FormBuilder, Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { greaterThanZero } from '../validators/customValidators';

export class FlightScheduleDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'startDate',
            type: 'Date',
            validators: [Validators.required]
        },
        {
            name: 'endDate',
            type: 'Date',
            validators: [Validators.required]
        },
        {
            name: 'spendingCap',
            type: 'number',
            validators: [greaterThanZero(false)]
        }
        // {
        //     name: 'impressionCap',
        //     type: 'number',
        //     validators: [greaterThanZero(true)]
        // }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
